import React from 'react'
import styled from 'styled-components'
import GuestCard from '@Features/LandingPage/GuestLanding/GuestCards/GuestCard'
import { useTranslation } from 'react-i18next'
import restAssured from '@Features/LandingPage/Assets/Illustrations/rest-assured.svg'
import practiceExam from '@Features/LandingPage/Assets/Illustrations/practice-exam.svg'
import followUp from '@Features/LandingPage/Assets/Illustrations/follow-up-with-guides.svg'
import studyMaterials from '@Features/LandingPage/Assets/Illustrations/study-materials.svg'

/**
 * "المدرس المساعد" learning-options section — four illustrated value cards.
 * Static marketing content (i18n copy + design-system illustrations).
 */
const GuestCards: React.FC = () => {
	const [t] = useTranslation('landingPage', { keyPrefix: 'mta' })

	const cards = [
		{ icon: restAssured, title: t('rest_assured_t', { defaultValue: 'خليك متطمن' }), body: t('rest_assured_b', { defaultValue: 'داعم ليك وناصح أمين من باب الثانوية لباب الكلية.' }) },
		{
			icon: practiceExam,
			title: t('practice_t', { defaultValue: 'اتدرب على الامتحان بذكاء' }),
			body: t('practice_b', { defaultValue: 'بيفكّرك بامتحاناتك ويصحّح لك عشان تعالج نقط ضعفك وتتطوّر.' }),
		},
		{ icon: followUp, title: t('ask_t', { defaultValue: 'اسأل براحتك' }), body: t('ask_b', { defaultValue: 'بيجاوبك على أسئلتك ويساعدك في أي وقت لو عطلان.' }) },
		{ icon: studyMaterials, title: t('start_t', { defaultValue: 'ابدأ بثقة' }), body: t('start_b', { defaultValue: 'المدرس المساعد بيعمل لك خطة مذاكرة ويتابعك عليها أول بأول.' }) },
	]

	return (
		<Section>
			<Heading>
				{t('title', { defaultValue: 'المدرس المساعد معاك من الباب للباب' })} <span>{t('grade', { defaultValue: '(ثانوية عامة)' })}</span>
			</Heading>
			<Grid>
				{cards.map((c, i) => (
					<GuestCard key={i} icon={c.icon} title={c.title} body={c.body} />
				))}
			</Grid>
		</Section>
	)
}

const Section = styled.section`
	padding: 12px 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`
const Heading = styled.h2`
	margin: 0;
	text-align: center;
	font: var(--fw-bold) var(--fs-body-lg)/1.4 var(--font-sans);
	color: var(--text-primary);
	span {
		color: var(--blue);
	}
	@media (min-width: 1024px) {
		font-size: 22px;
	}
`
const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
	@media (min-width: 1024px) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
`

export default GuestCards
